import { Dispatch, SetStateAction, useEffect } from "react"

import { ModifiedIncident } from ".."
import { Select, SelectOption } from "src/components/common/select"
import { joinToInlineString } from "src/helpers/nameUtils"
import { useBookings } from "src/states/bookings"

import { Dialogs, useDialog } from "src/states/dialogs"
import { TranslationMessages } from "src/translations"

type BookingSelectProps = {
  selectedBookingId: string
  messages: TranslationMessages
  setSelectedBookingId: Dispatch<SetStateAction<string>>
  setIncident: Dispatch<SetStateAction<ModifiedIncident>>
}

export const BookingSelect = ({
  messages,
  setIncident,
  selectedBookingId,
  setSelectedBookingId,
}: BookingSelectProps) => {
  const { bookings } = useBookings()
  const { disabled: isReadOnly } = useDialog(
    "incidentDialog",
  ) as Dialogs["incidentDialog"]

  const items = bookings.map((booking) => {
    return {
      key: booking.id,
      value: joinToInlineString([
        booking.name,
        booking.standhall
          ? `${messages?.components.core.header.standSelection.standhall}: ${booking.standhall}`
          : undefined,
        booking.standnumber
          ? `${messages?.components.core.header.standSelection.standnumber}: ${booking.standnumber}`
          : undefined,
      ]),
      onclick: () => {
        setSelectedBookingId(booking.id)
        setIncident((prev) => ({
          ...prev,
          incidentPositions: [],
          referenceRecordId: booking.id,
        }))
      },
    } as SelectOption
  })

  const selectedBooking: SelectOption | undefined = items.find(
    (selected) => selected.key === selectedBookingId,
  )

  useEffect(() => {
    setIncident((prev) => ({
      ...prev,
      referenceRecordId: selectedBookingId,
    }))
  }, [selectedBookingId, setIncident])

  return (
    <Select
      disabled={isReadOnly}
      items={items}
      sizeVariant="medium"
      value={selectedBooking?.key}
      variant="standard"
      label={
        messages?.pages.account.overview.profile.incidents.createDialog
          .cancellationFields.bookingSelect
      }
    />
  )
}

export default BookingSelect
